import { onError } from '@apollo/client/link/error';
import { t } from 'ttag';
import { useToastStore } from '~/ui/toast/toastStore';
import { ToastSeverity } from '~/ui/toast/types';

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    if (graphQLErrors && graphQLErrors[0] && graphQLErrors[0].message === 'Before you continue, please make sure to complete the current slide.') {
      return;
    }

    useToastStore.getState().add({
      severity: ToastSeverity.Error,
      message: t`An unexpected data error has occurred.`
    });
  }

  if (networkError) {
    useToastStore.getState().add({
      severity: ToastSeverity.Error,
      message: t`An unexpected network error has occurred.`
    });
  }
});
